import { makeStyles } from "@mui/styles";

export default makeStyles((theme) => ({
  loginContainer: {
    top: "0",
    left: "0",
    position: "fixed",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minWidth: "100vw",
    minHeight: "100vh",
    background: "url(/images/home/loginBg.webp)"
  },
  formGroup: {
    position: "relative",
    marginBottom: "20px",
    "& .MuiFormControl-root": {
      width: "100%"
    }
  },

  btnPrimary: {
    background: theme?.palette?.primary2TextColor?.main,
    borderRadius: "10px",
    padding: "6px 20px",
    color: `${theme?.palette?.secondaryText?.[700]} !important`,
    fontSize: "14px",
    fontWeight: "600",
    height: "45px",
    textTransform: "capitalize",
    width: "100%",
    "&:hover": {
      background: theme?.palette?.primaryBG?.[450],
      color: `${theme?.palette?.primaryText?.[100]} !important`
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px"
    }
  },
  loginLogo: {
    textAlign: "center",
    margin: "20px 0",
    "& img,svg": {
      width: "100px"
    }
  },
  loginFormWrap: {
    borderRadius: "10px",
    width: "600px",
    height: "400px",
    background: theme?.palette?.primaryBG?.[400],
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    "& .MuiInputBase-input": {
      height: "20px",
      padding: "10px",
      background: theme?.palette?.primaryBG?.[500],
      "&:hover": {
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: theme?.palette?.primary2TextColor?.main
        }
      }
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderRadius: "10px"
    },
    "& .MuiFormLabel-root": {
      top: "-5px",
      fontSize: "12px",
      color: theme?.palette?.primaryText?.[800]
    },
    "& fieldset": {
      borderColor: theme?.palette?.primaryBG?.[300]
    },
    "&::placeholder": {
      color: theme?.palette?.primaryText?.[800]
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: `${theme?.palette?.textFieldBorder} !important`
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      padding: "0 65px",
      height: "300px"
    }
  },
  showLink: {
    position: "absolute",
    right: "10px",
    top: "13px",
    fontSize: "10px",
    textDecoration: "none",
    color: "rgb(237 215 215)"
  },
  authBtnWrap: {
    margin: "30px 0",
    "& .MuiTypography-root": {
      textAlign: "center",
      fontWeight: "600"
    },
    [theme.breakpoints.down("sm")]: {
      margin: 0,
      marginTop: "16px"
    }
  }
}));
